export enum ACTION_TYPES {
	init="INITIALIZE",
	setLocation="SET_LOCATION",
	addLager="ADD_LAGER",
	clearCart="CLEAR_CART",
	editCartComment="EDIT_CART_COMMENT",
	editCartLagerComment="EDIT_CART_LAGER_COMMENT",
	editCartLager="EDIT_CART_LAGER",
	removeCartLager="EDIT_CART_LAGER"
}